import { useCallback, useEffect, useState } from 'react'
import { Box, Button, IconButton, Typography, MenuItem, Popover, MenuList, Modal, ThemeProvider, Divider, Grid, InputLabel, FormControl, Skeleton, Select, Pagination } from '@mui/material';
import Title from '../../Dashboard/Title';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useNavigate, useParams } from 'react-router-dom';
import { darkTheme, Search, SearchIconWrapper, style, StyledInputBase, StyledTableCell, StyledTableRow } from '../../../styles/styles';
import AddActivity from './AddActivity';
import { BsSearch } from 'react-icons/bs';
import { useSelector } from 'react-redux';
import api from "../../../services/QualityAssurance";
import { formatDateTime } from '../../../utils';
import { toast } from 'react-toastify';
import EditActivity from './EditActivity';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import TableLoader from '../../TableLoader';

const Activities = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const { admToken, user } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [calendarDropdown, setCalendarDropdown] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingCalendar, setLoadingCalendar] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selected, setSelected] = useState([]);
  const { calendarId } = useParams();
  const [calendarID, setCalendarID] = useState(calendarId || "");

  const [pagination, setPagination] = useState({
    pageNumber: 1,
    pageSize: 10,
    totalRecords: 0,
    totalPages: 0
  });
  const handleOpenModal = () => setOpenModal(true);
  const handleOpenEditModal = () => setOpenEditModal(true);
  const handleOpenDeleteModal = () => setOpenDeleteModal(true);
  const handleCloseDeleteModal = () => setOpenDeleteModal(false);

  const fetchCalendar = useCallback(async () => {
    try {
      setLoadingCalendar(true);
      const res = await api.getCalendars(
        admToken,
        '',
        10,
        1,
      );
      if (res.status && res.statusCode === 2) {
        setCalendarDropdown(res.data)
      }
      setLoadingCalendar(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoadingCalendar(false);
    }
  }, [admToken]);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const res = await api.getQAActivities(
        admToken,
        searchText,
        pagination.pageSize,
        pagination.pageNumber,
        calendarID
      );
      if (res.status && res.statusCode === 2) {
        setData(res.data)
        setPagination(prev => ({
          ...prev,
          totalRecords: res.totalRecord,
          totalPages: Math.ceil(res.totalRecord / pagination.pageSize),
          currentPage: res.currentPage || 1
        }));
        setSelected([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally{
      setLoading(false);
    }
  }, [admToken, searchText, pagination.pageSize, pagination.pageNumber, calendarID]);

  useEffect(() => {
    fetchCalendar();
  }, [fetchCalendar]);

  useEffect(() => {
    if (calendarID !== undefined) {
      fetchData();
    }
  }, [
    fetchData,
    calendarID,
    pagination.pageNumber,
    pagination.pageSize
  ]);  

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
    setPagination(prev => ({ ...prev, pageNumber: 1 }));
  };

  const handlePageChange = (event, newPage) => {
    setPagination(prev => ({ ...prev, pageNumber: newPage }));
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    fetchData();
  };

  const handleClick = (event, item) => {
    setAnchorEl(event.currentTarget);
    setSelectedItem(item);
    setSelectedItemId(item.id);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    handleClose();
    handleOpenEditModal();
  };
  const handleCloseEditModal = () => {
    setOpenEditModal(false);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleDelete = useCallback(async () => {
    try {
      if (!selectedItemId) return;
      const res = await api.deleteQAActivity(admToken, selectedItemId);
      if (res.status && res.statusCode === 2) {
        toast.success(res.data.message, {
          autoClose: 4000,
          position: toast.POSITION.BOTTOM_LEFT,
        });
        fetchData();
        handleCloseDeleteModal();
        handleClose();
      } else {
        toast.error(res.data.message)
      }
    } catch (error) {
      console.error(error);
    }
  }, [admToken, selectedItemId, fetchData]);

  const open = Boolean(anchorEl);
  const SeletcetdItemId = open ? "simple-popover" : undefined;

  return (
    <ThemeProvider theme={darkTheme}>
      <Box>
        <Box>
          <Title title="Quality Assurance" />
        </Box>
        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <button
            onClick={handleGoBack}
            className="flex items-center gap-2 text-[#691e78] font-medium my-4"
          >
            <IconButton sx={{ bgcolor: '#671e781a' }}>
              <KeyboardBackspaceIcon sx={{ color: '#671E78' }} />
            </IconButton>
            Go Back
          </button>
          <Button
            variant='contained'
            sx={{ textTransform: 'initial', fontFamily: 'Gilroy-Regular', marginTop: "10px" }}
            onClick={handleOpenModal}
          >
            Add Activity
          </Button>
        </Box>
        <Grid
          container
          spacing={2}
          sx={{
            display: "flex",
            bgcolor: "#691e78",
            borderRadius: "10px",
            justifyContent: "center",
            alignItems: "center",
            height: "fit",
            paddingBottom: "20px",
            marginTop: "10px",
          }}
        >
          <Grid item sm={8} xs={2}>
            <Box>
              <InputLabel
                sx={{
                  color: "#fff",
                  fontSize: "14px",
                  fontFamily: "gilroy-regular",
                }}
              >
                School Year
              </InputLabel>
              <FormControl fullWidth>
                <Select
                  sx={{
                    fontFamily: "Gilroy-Regular",
                    border: "1px solid white",
                    color: "#fff",
                  }}
                  displayEmpty
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  variant="outlined"
                  size="small"
                  value={calendarID ?? ''}
                  onChange={(e) => {
                    setCalendarID(e.target.value);
                    setPagination(prev => ({ ...prev, pageNumber: 1 }));
                  }}                  
                >
                  <MenuItem
                    sx={{ fontFamily: "Gilroy-Regular" }}
                    value="" disabled
                  >
                    <em>Choose year</em>
                  </MenuItem>
                  {loadingCalendar && (
                    <Box>
                      <Skeleton
                        variant="text"
                        animation="wave"
                        sx={{ fontSize: "2rem", mx: 2 }}
                      />
                      <Skeleton variant="rounded" height={60} sx={{ mx: 2 }} />
                      <Skeleton
                        variant="text"
                        animation="wave"
                        sx={{ fontSize: "1rem", mx: 2 }}
                      />
                    </Box>
                  )}
                  {(!calendarDropdown || calendarDropdown?.data?.length === 0) && !loadingCalendar ? (
                    <Box>
                      <Typography
                        sx={{
                          textAlign: "center",
                          fontSize: "12px",
                          fontWeight: "bolder",
                          color: "#333",
                          fontFamily: "Gilroy-Medium",
                        }}
                      >
                        No Session Available
                      </Typography>
                    </Box>
                  ) : (calendarDropdown?.length > 0 &&
                    calendarDropdown?.map((session) => (
                      <MenuItem
                        key={session.id}
                        value={session.id}
                        sx={{
                          fontFamily: "gilroy-regular",
                          fontSize: "13px",
                        }}
                      >
                        {session.sessionName}
                      </MenuItem>
                    ))
                  )}
                </Select>
              </FormControl>
            </Box>
          </Grid>
          <Grid item sm={3} xs={3}>
            <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
              <Button
                fullWidth
                variant="contained"
                sx={{
                  bgcolor: "#fff",
                  color: "#691e78",
                  "&:hover": { color: "#fff" },
                }}
                onClick={fetchData}
              >
                Fetch
              </Button>
            </Box>
          </Grid>
        </Grid>
        <Box mt={5} sx={{ border: "1px solid #671E78", borderRadius: "20px" }}>
          <Box
            sx={{
              pt: 4,
              background: "rgba(103, 30, 120, 0.1)",
              height: "100px",
              pl: { xs: 2.5 },
            }}
          >
            <Box component="form" onSubmit={handleSearchSubmit} sx={{ width: "100%" }}>
              <Search
                sx={{
                  width: {
                    lg: "345px",
                    md: "330px",
                    sm: "auto",
                    xs: "auto",
                    pl: { xs: 6 },
                  },
                }}
              >
                <SearchIconWrapper>
                  <BsSearch />
                </SearchIconWrapper>
                <StyledInputBase
                  placeholder="Search..."
                  inputProps={{ "aria-label": "search" }}
                  value={searchText}
                  onChange={handleSearchChange}
                />
              </Search>
            </Box>
          </Box>
          <TableContainer>
            <Table sx={{ minWidth: 700, fontFamily: "Gilroy-Regular" }} aria-label="customized table">
              <TableHead sx={{ backgroundColor: "rgba(103, 30, 120, 0.1)", width: "100%" }}>
                <TableRow>
                  <StyledTableCell>S/N</StyledTableCell>
                  <StyledTableCell>calendarId Year</StyledTableCell>
                  <StyledTableCell>Activity Title</StyledTableCell>
                  <StyledTableCell>From</StyledTableCell>
                  <StyledTableCell>To</StyledTableCell>
                  <StyledTableCell align='right'></StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody sx={{ fontFamily: "Gilroy-Regular" }}>
                {loading ?
                  <StyledTableRow>
                    <StyledTableCell colSpan={6} sx={{ textAlign: "center", fontSize: "14px", fontWeight: "bold", py: 2 }}>
                      <TableLoader />
                    </StyledTableCell>
                  </StyledTableRow>
                  : (
                    data?.length > 0 ? (
                      data?.map((item, index) => (
                        <StyledTableRow key={item.id || index}>
                          <StyledTableCell component="th" scope="row">{index + 1}</StyledTableCell>
                          <StyledTableCell>{item.session}</StyledTableCell>
                          <StyledTableCell>{item.name}</StyledTableCell>
                          <StyledTableCell>{item?.activityDateFrom ? formatDateTime(item.activityDateFrom) : ""}</StyledTableCell>
                          <StyledTableCell>{item?.activityDateTo ? formatDateTime(item.activityDateTo) : ""}</StyledTableCell>
                          <StyledTableCell align='right'>
                            <IconButton onClick={(e) => handleClick(e, item)}>
                              <MoreVertIcon />
                            </IconButton>
                          </StyledTableCell>
                        </StyledTableRow>
                      ))
                    ) : (
                      <StyledTableRow>
                        <StyledTableCell colSpan={7} align="center">
                          No activities found
                        </StyledTableCell>
                      </StyledTableRow>
                    )
                  )
                }
              </TableBody>
            </Table>
            {pagination.totalPages > 1 && (
              <Box sx={{ display: "flex", justifyContent: "end", mt: 3, mb: 2 }}>
                <Pagination
                  count={pagination.totalPages}
                  page={pagination.currentPage}
                  onChange={handlePageChange}
                  color="primary"
                  sx={{
                    '& .MuiPaginationItem-root': {
                      color: '#671E78',
                    },
                    '& .Mui-selected': {
                      backgroundColor: 'rgba(103, 30, 120, 0.1)',
                    },
                  }}
                  showFirstButton
                  showLastButton
                />
              </Box>
            )}
          </TableContainer>
        </Box>
      </Box>

      <Popover
        id={SeletcetdItemId}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box sx={{ bgcolor: "#671E78", color: "#fff", fontFamily: "Gilroy-Regular", px: 3 }}>
          <MenuList>
            <MenuItem
              sx={{ fontFamily: "Gilroy-Regular" }}
              onClick={handleEdit}
            >
              Edit
            </MenuItem>
            <MenuItem
              sx={{ fontFamily: "Gilroy-Regular" }}
              onClick={() => {
                if (selectedItem) {
                  handleClose();
                  handleOpenDeleteModal();
                }
              }}
            >
              Delete
            </MenuItem>
          </MenuList>
        </Box>
      </Popover>

      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box align="right">
            <IconButton onClick={handleCloseModal}>
              <HighlightOffIcon />
            </IconButton>
          </Box>
          <Box>
            <Typography variant="h4" sx={{ textAlign: "center", mb: 2, fontFamily: "Gilroy-Medium" }}>
              Add Activity
            </Typography>
            <Divider />
          </Box>
          <Box p={3} sx={{ overflowY: "scroll", height: "450px" }}>
            <AddActivity onSuccess={handleCloseModal} />
          </Box>
        </Box>
      </Modal>

      <Modal
        open={openEditModal}
        onClose={handleCloseEditModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box align="right">
            <IconButton onClick={handleCloseEditModal}>
              <HighlightOffIcon />
            </IconButton>
          </Box>
          <Box>
            <Typography variant="h4" sx={{ textAlign: "center", mb: 2, fontFamily: "Gilroy-Medium" }}>
              Edit Activity
            </Typography>
            <Divider />
          </Box>
          <Box p={3} sx={{ overflowY: "scroll", height: "450px" }}>
            <EditActivity id={selectedItemId} onSuccess={handleCloseEditModal} />
          </Box>
        </Box>
      </Modal>
      <Modal
        open={openDeleteModal}
        onClose={handleCloseDeleteModal}
        aria-labelledby="delete-confirmation-modal"
      >
        <Box sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          borderRadius: "10px",
          boxShadow: 24,
          p: 4,
        }}>
          <Typography variant="h6" sx={{ fontFamily: "Gilroy-Medium", mb: 2 }}>
            Confirm Delete
          </Typography>
          <Typography variant="body1" sx={{ fontFamily: "Gilroy-Regular", mb: 3 }}>
            Are you sure you want to delete this question?
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
            <Button
              variant="outlined"
              onClick={handleCloseDeleteModal}
              sx={{ textTransform: 'initial', fontFamily: "Gilroy-Regular" }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleDelete}
              sx={{
                textTransform: 'initial',
                fontFamily: "Gilroy-Regular",
                bgcolor: '#671E78',
                '&:hover': { bgcolor: '#4e165a' }
              }}
            >
              Delete
            </Button>
          </Box>
        </Box>
      </Modal>
    </ThemeProvider>
  )
}

export default Activities;